<template>
    <wrapper-features-templates-one-column
    noWhiteBox
    nonAuthenticatedFeature
    :customBreadcrumbs="customBreadcrumbs"
    @backOrCloseClicked="emit('backOrCloseClicked')">
        <div class="content-info-wrapper">
            <div class="title">{{t('join.createAccount.webInfoPage.title')}}</div>
            <div class="text">{{t('join.createAccount.webInfoPage.text1')}}</div>
            <div class="qr-code-title">{{t('join.createAccount.webInfoPage.qrCodeTitle')}}</div>
            <div class="center-wrapper">
                <div class="qr-code">
                    <img src="https://ib.bancobai.ao/FILES/baidirecto-retail-qr.svg" alt="qr-code">
                </div>
            </div>
            <div class="text">{{t('join.createAccount.webInfoPage.text2')}}</div>
            <div class="text" v-html="t('join.createAccount.webInfoPage.text3')"></div>
        </div>
    </wrapper-features-templates-one-column>
</template>

<script setup>
import WrapperFeaturesTemplatesOneColumn from '@/components/wrappers/featuresTemplates/OneColumn'
import TabSegment from '@/components/generic/tabs/Segment'

/* Vue & Assets */
import { ref, computed } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['backOrCloseClicked'])

/* props received
@customBreadcrumbs { Object }
*/
const props = defineProps({
    customBreadcrumbs: Object
})
</script>

<style lang="scss" scoped>
.content-info-wrapper {
    width: 100%;
    max-width: 508px;
    margin: 0 auto;

    display: flex;
    flex-direction: column;

    .title {
        width: 100%;
        margin-bottom: 8px;

        @include H2-Medium;
        color: var(--primary);
    }

    .text {
        width: 100%;
        margin-bottom: 24px;

        @include H6-Regular;
        color: var(--secondary-dark-2);
        line-height: 18px;

        &:last-of-type {
            margin-top: 8px;
        }
    }

    .qr-code-title {
        width: 100%;
        margin-bottom: 32px;

        @include H6-Medium;
        color: var(--secondary-dark-2);
        line-height: 18px;
    }

    .center-wrapper {
        width: 100%;
        margin-bottom: 32px;

        display: flex;
        flex-direction: column;
        align-items: center;

        .tabs-segment-wrapper {
            margin-bottom: 16px;

           :deep(.tab) {
                width: 82px;
            }
        }

        .qr-code {
            width: 164px;
            height: 164px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
